module.exports = __webpack_public_path__ + "assets/img/ai-center.2d3d2098.png";